import Vue from 'vue';
import BillingsBasic from '@/plugins/graphql/queries/v2/billings-basic.gql';
import { BillingBasicModel } from '@/helpers/entities/models/BillingBasicModel';
export default Vue.extend({
    apollo: {
        billings: {
            query: BillingsBasic,
            variables() {
                return {
                    appUuid: this.appUuid,
                };
            },
            update(data) {
                return data.billings.edges.map((billingNode) => {
                    return new BillingBasicModel(billingNode.node);
                });
            },
        },
    },
    props: {
        appUuid: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            billings: [],
        };
    },
    computed: {
        dataForCsv() {
            const self = this;
            if (self.billings.length >= 1) {
                return self.billings.map((billing) => {
                    return {
                        billingNumber: billing.referenceNumber,
                        billingPeriod: `${billing.formattedBillingStartDate} - ${billing.formattedBillingEndDate}`,
                        amount: `${billing.currentAmount}`,
                        dueDate: billing.formattedBillingDueDate,
                        tierType: billing.humanizedTierType,
                        status: billing.humanizedStatus,
                    };
                });
            }
            return [];
        },
    },
    render() {
        if (this.$scopedSlots.default) {
            const self = this;
            return this.$scopedSlots.default({
                billings: self.dataForCsv,
            });
        }
    },
});
